import { jsonRequest } from "@/helpers/wordpress";

export async function getCompanies() {
  const response = await jsonRequest("GET", "my_profile_companies");
  const companies = await response.json();

  if (Object.keys(companies).includes("error")) {
    throw new Error(companies.error.join("; "));
  }

  return companies.companies;
}

export async function getCompany(id) {
  const response = await jsonRequest("GET", "my_profile_company", null, { id });
  const company = await response.json();

  if (Object.keys(company).includes("error")) {
    throw new Error(company.error.join("; "));
  }

  return company;
}

export function contactModelDefaults() {
  return {
    id: 0,
    title: "",
    full_name: "",
    job_title: "",
    phone: "",
    email: "",
    photo: null,
  };
}

export async function userProfile() {
  const response = await jsonRequest("GET", "inc_members_my_profile");
  const user = await response.json();

  if (Object.keys(user).includes("error")) {
    throw new Error(user.error.join("; "));
  }

  return user;
}
